/* This module provides authentication context */

import React, { useContext, useState, createContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import jwt_decode from 'jwt-decode';
import { getAuthToken, authenticate } from 'lib/auth';

const AuthContext = createContext({});

const AuthProvider = ({ children }) => {
  const location = useLocation();
  const [isAuthLoading, setIsAuthLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(
    Boolean(getAuthToken()),
  );
  const [authType, setAuthType] = useState();

  useEffect(() => {
    const auth = async () => {
      try {
        const urlQuery = queryString.parse(location.search);
        await authenticate(urlQuery.token);
        setIsAuthenticated(Boolean(getAuthToken()));
      } catch {
        setIsAuthenticated(false);
      }
      setIsAuthLoading(false);
    };

    if (!getAuthToken()) {
      auth();
    } else {
      const decoded = jwt_decode(getAuthToken());
      setAuthType(decoded.kind);
      setIsAuthLoading(false);
    }
  }, [location.search]);

  const contextValue = {
    isAuthLoading,
    isAuthenticated,
    authType,
  };

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export default AuthProvider;
